"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityEmbedDialog = exports.EntityEmbedDialogDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_1 = require("../elements/dialog");
var entity_search_select_1 = require("./entity-search-select");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var icon_button_1 = require("../elements/icon-button");
var use_modal_1 = require("../../hooks/use-modal");
var use_entities_1 = require("../../hooks/use-entities");
var lodash_1 = require("lodash");
exports.EntityEmbedDialogDefaultProps = {
  entityTypeNames: [],
  onConfirm: function (entity) {
    console.log(entity);
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var SearchStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(4))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(1))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-left: 2px solid ", ";\n    padding-left: ", ";\n    margin: ", " 0 ", ";\n    color: ", ";\n    font-size: ", ";\n  "], ["\n    border-left: 2px solid ", ";\n    padding-left: ", ";\n    margin: ", " 0 ", ";\n    color: ", ";\n    font-size: ", ";\n  "])), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(0.5), theme_1.theme.COLOR('text-subtle'), theme_1.theme.FONT_SIZE(13))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Body: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Description: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Label: styled_components_1.default.label(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Search: (0, styled_components_1.default)(entity_search_select_1.EntitySearchSelect)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SearchStyles),
  Button: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
var EntityEmbedDialog = function (props) {
  var className = props.className,
    entityTypeNames = props.entityTypeNames,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, use_lang_1.useLang)();
  var title = t('Embed Platform Item');
  var Icons = (0, use_icons_1.useIcons)();
  var modal = (0, use_modal_1.useModal)();
  var _a = __read((0, react_1.useState)(), 2),
    value = _a[0],
    setValue = _a[1];
  var button = react_1.default.createElement(My.Button, {
    disabled: !value,
    onClick: function () {
      onConfirm(value.entity);
    },
    icon: react_1.default.createElement(Icons.TickCircle, null)
  }, t('Embed Item'));
  var embeddableEntityTypeNames = __spreadArray(__spreadArray([], __read((0, lodash_1.map)((0, lodash_1.pickBy)(entities, function (defn) {
    return defn.canEmbed;
  }), function (defn) {
    return defn.name;
  })), false), ['ImageAsset'], false);
  return react_1.default.createElement(My.Dialog, {
    icon: Icons.FrameCircle,
    title: title,
    onCancel: onCancel,
    showCancelButton: true,
    className: className,
    button: button
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Label, null, t('Platform Item')), react_1.default.createElement(My.Description, null, t('Search for a platform item to embed into the content field:')), react_1.default.createElement(My.Search, {
    isSearchable: true,
    autoFocus: true,
    isClearable: true,
    entityTypeNames: embeddableEntityTypeNames,
    variant: "default",
    value: value,
    onChange: function (value) {
      setValue(value);
    }
  })));
};
exports.EntityEmbedDialog = EntityEmbedDialog;
exports.EntityEmbedDialog.defaultProps = exports.EntityEmbedDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;